export default __webpack_public_path__ + "static/media/buddy-napoleon.6e8b55d1.png";